import stateStore from "@/store";
import { isArray } from "./utils";

export function availabeRole(value: any) {
	const rolesRaw: any = stateStore.state?.user?.roles;
	const roles: string[] = Array.isArray(rolesRaw)
		? rolesRaw.map((r: any) => String(r).trim())
		: [];

	if (typeof value == 'boolean') {

		return value;

	} else if (typeof value == 'string') {

		return roles.includes(value);

	} else if (isArray(value)) {

		for (const role of value) {
			if (roles.includes(role)) return true;
		}
	}

	return false;
}
